import React from "react";
import { Col, Container, Row, Tabs, Tab, Accordion } from "react-bootstrap";
import { Link } from "gatsby";

function Appbuild(props) {
  return (
    <div className="services_buildapp p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Case Studies">
              <h2>Explore Our Successful Cloud Managed Solutions</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              As a leading cloud-managed services provider, we pride ourselves
              on delivering inclusive and user-centric cloud solutions
              customized to our clients' unique needs. Our dedicated team of
              experts ensures flawless integration, optimization, and ongoing
              support for cloud solutions, empowering businesses to thrive in
              the digital market. Have a look at our proven products
              successfully sustaining in the market:
            </p>
          </Col>
        </Row>
        <Row className="services_bg ">
          <Col
            xs={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="services_tabs deskstop_version"
          >
            <Tabs defaultActiveKey="0" transition={false}>
              <Tab eventKey="0" title="Gaming">
                <div className="content_tabs">
                  <h2>Ether Legend</h2>
                  <p>
                    Ether Legends is a blockchain-based NFT card trading game
                    that is backed by the Ethereum, Polygon, and Enjin networks
                    created by TekRevol. Users can gather NFTs as rewards and
                    store them as digital assets due to the game's
                    "play-to-earn" feature.
                  </p>
                  <p>
                    Our mobile game development services create games for many
                    operating systems, giving players an incredible gaming
                    experience.
                  </p>
                  <Link to="/case-studies/ether-legends">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="1" title="Productivity">
                <div className="content_tabs">
                  <h2>AMJ Wellness</h2>
                  <p>
                    AMJ Wellness is an app developed by TekRevol that guarantees
                    employees' mental and physical well-being and maps them to
                    their productivity. This digital solution ensures a healthy
                    relationship between employee well-being and productivity.
                    Later, all this ties to overall organizational performance.
                  </p>
                  <Link to="/case-studies/amj-wellness">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="2" title="Marketplace">
                <div className="content_tabs">
                  <h2>High Def Events</h2>
                  <p>
                    A unique digital auctioneering platform, the High Def Events
                    app lets users engage with it, produce films and images of
                    their goods, list them for sale on appropriate screens, and
                    entice customers to purchase them using the app.
                  </p>
                  <Link to="/case-studies/hde">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="3" title="Socializing">
                <div className="content_tabs">
                  <h2>TeeMates</h2>
                  <p>
                    Teemates is a socializing platform, especially for golfers
                    built by TekRevol experts. The app contains all the
                    necessary as well as advanced features for the golfer
                    community. After registration, users can collaborate, share
                    their stories, and connect with golfers across the globe.
                  </p>
                  <Link to="/case-studies/teemates">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="4" title="Entertainment">
                <div className="content_tabs">
                  <h2>FSK</h2>
                  <p>
                    FSK redefines mobile gaming by seamlessly blending match-3
                    puzzles, time managementchallenges, and role-playing
                    elements. Players embark on a culinary adventure,building a
                    restaurant empire, and applying real-time market strategies
                    to crafttheir success.
                  </p>
                  <Link to="/case-studies/fsk">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="5" title="Lifestyle">
                <div className="content_tabs">
                  <h2>Stop Vaping</h2>
                  <p>
                    Digital lifestyle items such as desktop programs, smartwatch
                    widgets, and web apps are used by a large global market.
                    With a variety of monetization options, these digital
                    solutions offer consumers products, information, and useful
                    content while also offering enormous financial
                    possibilities. TekRevol is capable of creating the ideal
                    lifestyle option for you.
                  </p>
                  <Link to="/case-studies/stop-vaping">See case study</Link>
                </div>
              </Tab>
            </Tabs>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="services_tabs mobile_version"
          >
            <div className="tekrevol_mobile_accordion">
              <Accordion defaultActiveKey="01">
                <Accordion.Item eventKey="01">
                  <Accordion.Header>Ether Legend</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Ether Legends is a blockchain-based NFT card trading game
                      that is backed by the Ethereum, Polygon, and Enjin
                      networks created by TekRevol. Users can gather NFTs as
                      rewards and store them as digital assets due to the game's
                      "play-to-earn" feature.
                    </p>
                    <p>
                      <p>
                        Our mobile game development services create games for
                        many operating systems, giving players an incredible
                        gaming experience.
                      </p>
                    </p>
                    <Link to="/case-studies/ether-legends">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="02">
                  <Accordion.Header>AMJ Wellness</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      AMJ Wellness is an app developed by TekRevol that
                      guarantees employees' mental and physical well-being and
                      maps them to their productivity. This digital solution
                      ensures a healthy relationship between employee well-being
                      and productivity. Later, all this ties to overall
                      organizational performance.
                    </p>
                    <Link to="/case-studies/amj-wellness">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="03">
                  <Accordion.Header>High Def Events</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      A unique digital auctioneering platform, the High Def
                      Events app lets users engage with it, produce films and
                      images of their goods, list them for sale on appropriate
                      screens, and entice customers to purchase them using the
                      app.
                    </p>
                    <Link to="/case-studies/hde">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="04">
                  <Accordion.Header>TeeMates</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Teemates is a socializing platform, especially for golfers
                      built by TekRevol experts. The app contains all the
                      necessary as well as advanced features for the golfer
                      community. After registration, users can collaborate,
                      share their stories, and connect with golfers across the
                      globe.
                    </p>
                    <Link to="/case-studies/teemates">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="05">
                  <Accordion.Header>FSK</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      FSK redefines mobile gaming by seamlessly blending match-3
                      puzzles, time managementchallenges, and role-playing
                      elements. Players embark on a culinary adventure,building
                      a restaurant empire, and applying real-time market
                      strategies to crafttheir success.
                    </p>
                    <Link to="/case-studies/fsk">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="06">
                  <Accordion.Header>Stop Vaping</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Digital lifestyle items such as desktop programs,
                      smartwatch widgets, and web apps are used by a large
                      global market. With a variety of monetization options,
                      these digital solutions offer consumers products,
                      information, and useful content while also offering
                      enormous financial possibilities. TekRevol is capable of
                      creating the ideal lifestyle option for you.
                    </p>
                    <Link to="/case-studies/stop-vaping">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={4}
            xl={4}
            xxl={4}
            className="services_grade_tabs"
          >
            <Tabs defaultActiveKey="0">
              <Tab eventKey="0" title="Silver">
                <div className="tab_hour">
                  <h4>
                    1172 Hours<span>Average Development Time</span>
                  </h4>
                  <h4>
                    07 Months<span>Average Project Length</span>
                  </h4>
                </div>
              </Tab>
              <Tab eventKey="1" title="Gold">
                <div className="tab_hour">
                  <h4>
                    1619 Hours<span>Average Development Time</span>
                  </h4>
                  <h4>
                    09 Months<span>Average Project Length</span>
                  </h4>
                </div>
              </Tab>
              <Tab eventKey="2" title="Platinum">
                <div className="tab_hour">
                  <h4>
                    3116 Hours<span>Average Development Time</span>
                  </h4>
                  <h4>
                    18 Months<span>Average Project Length</span>
                  </h4>
                </div>
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Appbuild;
